export function log(context) {
  const data = JSON.stringify(context);
  const blob = new Blob([data], { type: 'application/json' });

  navigator.sendBeacon('/collect', blob);
}
